const LOG_LEVELS = {
  debug: 10,
  info: 20,
  warn: 30,
  error: 40,
  silent: 50,
};

const FALLBACK_LEVEL = process.env.NODE_ENV === 'production' ? 'warn' : 'debug';

const normalizeLevel = (level, fallback = FALLBACK_LEVEL) => {
  const normalized = String(level || '').trim().toLowerCase();
  return Object.prototype.hasOwnProperty.call(LOG_LEVELS, normalized)
    ? normalized
    : fallback;
};

const getCurrentLevel = () =>
  normalizeLevel(process.env.REACT_APP_LOG_LEVEL, FALLBACK_LEVEL);

const shouldLog = (level) => {
  const targetLevel = LOG_LEVELS[normalizeLevel(level)];
  const currentLevel = LOG_LEVELS[getCurrentLevel()];
  return targetLevel >= currentLevel;
};

const getConsoleMethod = (level) => {
  if (typeof console === 'undefined') {
    return null;
  }

  if (level === 'debug' && typeof console.debug === 'function') {
    return console.debug.bind(console);
  }

  if (level === 'info' && typeof console.info === 'function') {
    return console.info.bind(console);
  }

  if (level === 'warn' && typeof console.warn === 'function') {
    return console.warn.bind(console);
  }

  if (level === 'error' && typeof console.error === 'function') {
    return console.error.bind(console);
  }

  if (typeof console.log === 'function') {
    return console.log.bind(console);
  }

  return null;
};

const log = (level, ...args) => {
  if (!shouldLog(level)) {
    return;
  }

  const method = getConsoleMethod(level);
  if (method) {
    method(...args);
  }
};

export const debug = (...args) => log('debug', ...args);
export const info = (...args) => log('info', ...args);
export const warn = (...args) => log('warn', ...args);
export const error = (...args) => log('error', ...args);

const logger = {
  debug,
  info,
  warn,
  error,
  log: (...args) => log('info', ...args),
  levels: { ...LOG_LEVELS },
  getLevel: getCurrentLevel,
};

export default logger;
